import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoNoConfig } from './presets/contact-axo-no.config';
import { globalNo } from './presets/global-no.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { organisationAxoNoConfig } from './presets/organisation-axo-no.config';
import { serviceTrustpilotAxoNoConfig } from './presets/service-trustpilot-axo-no.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';

export const global: GlobalConfig = {
  brand: 'axofinans.no',
  ...globalNo,
};

export const site: SiteConfig = {
  domain: 'axofinans.no',
  theme: {
    name: 'axo-finans',
    brand: 'axo-finans',
  },
  path: {
    loansApply: '/soknad/forbrukslan',
    mypage: 'https://mypage.axofinans.no',
  },
  ...organisationAxoNoConfig,
  ...contactAxoNoConfig,
  services: {
    trustpilot: serviceTrustpilotAxoNoConfig,
    gtm: 'GTM-T9326N',
    ga: 'G-VM1458YKKN',
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: { hasHighCostWarning: false, ...myPageOffersConfig },
};
